import React, { useEffect, useState } from "react";
import { FaUserCircle, FaMoon, FaSun, FaSignOutAlt, FaKey, FaUser, FaSave, FaBars, FaBell } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

import logoPrincipal from "../assets/logo.png";
import logoVRI from "../assets/logo.vri.png";
import logoSerbom from "../assets/logo.serbom.png";

import CentralInteracao from "./CentralInteracao";

function Header({ username, email, tipo, toggleTheme, isDarkMode, menuRecolhido, toggleMenu }) {
  const navigate = useNavigate();

  /*
   * =====================================================
   * MENU / USUÁRIO
   * =====================================================
   */

  const [menuOpen, setMenuOpen] = useState(false);

  const [showPerfil, setShowPerfil] = useState(false);

  const [showTrocarSenha, setShowTrocarSenha] = useState(false);

  const [novaSenha, setNovaSenha] = useState("");

  const [confirmarSenha, setConfirmarSenha] = useState("");

  /*
   * =====================================================
   * CENTRAL DE INTERAÇÃO
   * =====================================================
   *
   * O Header NÃO possui mais uma Central própria.
   *
   * Ele mantém somente:
   *
   * - quantidade para o contador do Header;
   * - informação de aberto/fechado.
   *
   * O conteúdo é renderizado pelo componente:
   *
   * CentralInteracao.js
   * =====================================================
   */

  const [quantidadePendencias, setQuantidadePendencias] = useState(0);

  const [showCentralInteracao, setShowCentralInteracao] = useState(false);

  /*
   * =====================================================
   * EMPRESA / LOGO
   * =====================================================
   */

  const empresaSigla = (localStorage.getItem("empresa_sigla") || localStorage.getItem("empresaSigla") || "").toUpperCase();

  const logoSecundaria = empresaSigla === "VSA" ? logoSerbom : logoVRI;

  /*
   * =====================================================
   * TOKEN
   * =====================================================
   */

  const getToken = () => {
    return (
      localStorage.getItem("token") ||
      localStorage.getItem("authToken") ||
      localStorage.getItem("jwtToken") ||
      localStorage.getItem("jwt") ||
      localStorage.getItem("userToken")
    );
  };

  /*
   * =====================================================
   * QUANTIDADE DE PENDÊNCIAS DO HEADER
   * =====================================================
   *
   * Esta consulta serve SOMENTE para manter o contador
   * ao lado de CENTRAL DE INTERAÇÃO.
   *
   * A lista completa é carregada pelo próprio
   * CentralInteracao.js.
   * =====================================================
   */

  const buscarPendencias = async () => {
    const token = getToken();

    if (!token) {
      setQuantidadePendencias(0);
      return;
    }

    try {
      const response = await fetch("/api/pendencias-aprovacao", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Erro HTTP ${response.status}`);
      }

      const data = await response.json();

      const lista = Array.isArray(data?.pendencias) ? data.pendencias : [];

      setQuantidadePendencias(Number.isInteger(data?.quantidade) ? data.quantidade : lista.length);
    } catch (err) {
      console.error("Erro ao buscar pendências da Central de Interação:", err);

      /*
       * O Header não deve quebrar caso a API
       * esteja temporariamente indisponível.
       */
      setQuantidadePendencias(0);
    }
  };

  /*
   * =====================================================
   * ATUALIZAÇÃO AUTOMÁTICA
   * =====================================================
   *
   * Mantém a regra já definida:
   *
   * - consulta inicial;
   * - atualização a cada 60 segundos;
   * - atualização ao retornar para a janela.
   * =====================================================
   */

  useEffect(() => {
    buscarPendencias();

    const intervalo = setInterval(buscarPendencias, 60000);

    const atualizarAoFocar = () => {
      buscarPendencias();
    };

    window.addEventListener("focus", atualizarAoFocar);

    return () => {
      clearInterval(intervalo);

      window.removeEventListener("focus", atualizarAoFocar);
    };
  }, []);

  /*
   * =====================================================
   * LOGOUT
   * =====================================================
   */

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("authToken");
    localStorage.removeItem("jwtToken");
    localStorage.removeItem("jwt");
    localStorage.removeItem("userToken");
    localStorage.removeItem("usuario");
    localStorage.removeItem("tipoUsuario");

    navigate("/");
  };

  /*
   * =====================================================
   * TROCAR SENHA
   * =====================================================
   */

  const handleTrocarSenha = async () => {
    if (!novaSenha || !confirmarSenha) {
      alert("Preencha os dois campos de senha.");
      return;
    }

    if (novaSenha !== confirmarSenha) {
      alert("As senhas não conferem.");
      return;
    }

    if (novaSenha.length < 6) {
      alert("A senha deve ter pelo menos 6 caracteres.");
      return;
    }

    const token = getToken();

    if (!token) {
      alert("Token não encontrado! Faça login novamente.");
      return;
    }

    try {
      const res = await fetch("/api/usuarios/trocar-senha", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          novaSenha,
          confirmarSenha,
        }),
      });

      const data = await res.json();

      if (res.ok) {
        alert(data?.mensagem || "Senha alterada com sucesso.");

        setShowTrocarSenha(false);
        setNovaSenha("");
        setConfirmarSenha("");
      } else {
        alert(data?.erro || data?.mensagem || "Erro ao alterar senha.");
      }
    } catch (err) {
      console.error("Erro ao trocar senha:", err);

      alert("Erro de conexão.");
    }
  };

  /*
   * =====================================================
   * RENDER
   * =====================================================
   */

  return (
    <>
      {/* =================================================
          HEADER
      ================================================== */}

      <header
        className="
          fixed
          top-0
          left-0
          right-0
          h-16
          bg-[#1c1f26]
          text-white
          flex
          items-center
          justify-between
          px-4
          shadow-md
          z-50
        "
      >
        {/* ===============================================
            LADO ESQUERDO
        =============================================== */}

        <div className="flex items-center gap-3 flex-shrink-0">
          {/* MENU */}
          <button
            type="button"
            onClick={toggleMenu}
            className="
              w-9
              h-9
              p-0
              flex
              items-center
              justify-center
              flex-shrink-0
              rounded-md
              bg-transparent
              text-white
              hover:bg-[#2a2d36]
              transition-colors
              focus:outline-none
              focus:ring-0
            "
            title={menuRecolhido ? "Expandir menu" : "Recolher menu"}
            aria-label={menuRecolhido ? "Expandir menu" : "Recolher menu"}
          >
            <FaBars size={18} />
          </button>

          {/* LOGOS */}
          <div className="flex items-center gap-2 flex-shrink-0">
            <img
              src={logoPrincipal}
              alt="ImobGest"
              className="
                h-12
                w-auto
                object-contain
                flex-shrink-0
              "
            />

            <img
              src={logoSecundaria}
              alt={empresaSigla || "Empresa"}
              className="
                ml-2
                h-8
                w-auto
                object-contain
                opacity-90
                flex-shrink-0
              "
            />
          </div>
        </div>

        {/* ===============================================
            LADO DIREITO
        =============================================== */}

        <div className="flex items-center space-x-3">
          {/* =============================================
              CENTRAL DE INTERAÇÃO
          ============================================= */}

          <button
            type="button"
            onClick={() => setShowCentralInteracao(true)}
            className="
              relative
              flex
              items-center
              gap-2
              px-3
              py-2
              rounded-md
              bg-transparent
              text-white
              hover:bg-[#2a2d36]
              transition-colors
              focus:outline-none
              focus:ring-0
            "
            title="Central de Interação"
            aria-label="Central de Interação"
          >
            <FaBell size={16} />

            <span
              className="
                text-xs
                font-semibold
                tracking-wide
                whitespace-nowrap
              "
            >
              CENTRAL DE INTERAÇÃO
            </span>

            <span
              className={`
                min-w-[22px]
                h-[22px]
                px-1
                rounded-full
                flex
                items-center
                justify-center
                text-[11px]
                font-bold
                ${quantidadePendencias > 0 ? "bg-orange-500 text-white" : "bg-gray-600 text-gray-200"}
              `}
            >
              {quantidadePendencias}
            </span>
          </button>

          {/* USUÁRIO */}
          <span className="text-sm font-medium whitespace-nowrap">{username}</span>

          {/* TEMA */}
          <button
            type="button"
            onClick={toggleTheme}
            className="
              p-1
              rounded
              bg-[#1c1f26]
              hover:bg-[#2a2d36]
              text-white
              text-sm
              transition-colors
            "
            title="Alternar tema"
          >
            {isDarkMode ? <FaSun size={15} /> : <FaMoon size={15} />}
          </button>

          {/* =============================================
              MENU DO USUÁRIO
          ============================================= */}

          <div className="relative">
            <button
              type="button"
              onClick={() => setMenuOpen(!menuOpen)}
              className="
                p-1
                rounded
                bg-[#1c1f26]
                hover:bg-[#2a2d36]
                text-white
                text-xl
                transition-colors
              "
              title="Opções do usuário"
            >
              <FaUserCircle />
            </button>

            {menuOpen && (
              <div
                className="
                  absolute
                  right-0
                  mt-2
                  w-48
                  bg-[#2a2d36]
                  text-white
                  rounded
                  shadow-lg
                  z-50
                "
              >
                {/* PERFIL */}
                <button
                  type="button"
                  onClick={() => {
                    setShowPerfil(true);
                    setMenuOpen(false);
                  }}
                  className="
                    flex
                    items-center
                    w-full
                    px-4
                    py-2
                    hover:bg-[#3b4a5a]
                  "
                >
                  <FaUser className="mr-2" />
                  Perfil
                </button>

                {/* TROCAR SENHA */}
                <button
                  type="button"
                  onClick={() => {
                    setShowTrocarSenha(true);
                    setMenuOpen(false);
                  }}
                  className="
                    flex
                    items-center
                    w-full
                    px-4
                    py-2
                    hover:bg-[#3b4a5a]
                  "
                >
                  <FaKey className="mr-2" />
                  Trocar Senha
                </button>

                {/* SAIR */}
                <button
                  type="button"
                  onClick={handleLogout}
                  className="
                    flex
                    items-center
                    w-full
                    px-4
                    py-2
                    hover:bg-[#3b4a5a]
                  "
                >
                  <FaSignOutAlt className="mr-2" />
                  Sair
                </button>
              </div>
            )}
          </div>
        </div>
      </header>

      {/* =================================================
          CENTRAL DE INTERAÇÃO

          IMPORTANTE:
          É EXATAMENTE O MESMO COMPONENTE UTILIZADO
          NA PÁGINA PRINCIPAL.
      ================================================== */}

      {showCentralInteracao && <CentralInteracao modo="overlay" onFechar={() => setShowCentralInteracao(false)} onQuantidadeChange={setQuantidadePendencias} />}

      {/* =================================================
          PERFIL
      ================================================== */}

      {showPerfil && (
        <div
          className="
            fixed
            inset-0
            bg-black
            bg-opacity-50
            flex
            justify-center
            items-center
            z-50
          "
        >
          <div className="bg-white p-6 rounded shadow-lg w-96 text-gray-900">
            <h2 className="text-xl font-bold mb-4 text-center">Perfil do Usuário</h2>

            <p className="mb-2">
              <strong>Nome:</strong> {username}
            </p>

            <p className="mb-2">
              <strong>Email:</strong> {email}
            </p>

            <p className="mb-4">
              <strong>Tipo:</strong> {tipo}
            </p>

            <button
              type="button"
              onClick={() => setShowPerfil(false)}
              className="
                mt-2
                px-4
                py-2
                bg-gray-800
                text-white
                rounded
                hover:bg-gray-700
              "
            >
              Fechar
            </button>
          </div>
        </div>
      )}

      {/* =================================================
          TROCAR SENHA
      ================================================== */}

      {showTrocarSenha && (
        <div
          className="
            fixed
            inset-0
            bg-black
            bg-opacity-50
            flex
            justify-center
            items-center
            z-50
          "
        >
          <div className="bg-white p-6 rounded shadow-lg w-96 text-gray-900">
            <h2 className="text-xl font-bold mb-4 text-center">Trocar Senha</h2>

            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleTrocarSenha();
              }}
            >
              <input
                type="password"
                placeholder="Nova senha"
                value={novaSenha}
                onChange={(e) => setNovaSenha(e.target.value)}
                className="
                  w-full
                  mb-3
                  px-4
                  py-2
                  border
                  border-gray-400
                  rounded
                "
                autoComplete="new-password"
              />

              <input
                type="password"
                placeholder="Confirmar nova senha"
                value={confirmarSenha}
                onChange={(e) => setConfirmarSenha(e.target.value)}
                className="
                  w-full
                  mb-4
                  px-4
                  py-2
                  border
                  border-gray-400
                  rounded
                "
                autoComplete="new-password"
              />

              <div className="flex justify-between">
                <button
                  type="submit"
                  className="
                    flex
                    items-center
                    gap-2
                    bg-green-600
                    hover:bg-green-700
                    text-white
                    px-4
                    py-2
                    rounded
                    text-sm
                  "
                >
                  <FaSave size={14} />
                  Salvar
                </button>

                <button
                  type="button"
                  onClick={() => setShowTrocarSenha(false)}
                  className="
                    bg-gray-500
                    hover:bg-gray-600
                    text-white
                    px-4
                    py-2
                    rounded
                    text-sm
                  "
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}

export default Header;
